import SearchForm from 'components/SearchForm/SearchForm'

export default SearchForm
